// プレーヤのボタン用 SVG アイコン（絵文字を使わず描画）。currentColor で色追従。
const S = (inner, opts = '') =>
  `<svg viewBox="0 0 24 24" ${opts} aria-hidden="true">${inner}</svg>`
const stroke = 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"'
const fill = 'fill="currentColor" stroke="none"'

export const ICONS = {
  back: S('<path d="M15 5l-7 7 7 7"/>', stroke),
  // 閉じる（×）
  close: S('<path d="M6 6l12 12M18 6L6 18"/>', stroke),
  // 設定（スライダー）
  gear: S(
    '<line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/><circle cx="14" cy="7" r="2.4" fill="#1a1d24"/><circle cx="8" cy="12" r="2.4" fill="#1a1d24"/><circle cx="16" cy="17" r="2.4" fill="#1a1d24"/>',
    stroke
  ),
  // 字幕(CC)
  subtitle: S(
    '<rect x="3" y="5" width="18" height="14" rx="2.5"/><line x1="7" y1="11" x2="12" y2="11"/><line x1="15" y1="11" x2="17" y2="11"/><line x1="7" y1="15" x2="10" y2="15"/><line x1="13" y1="15" x2="17" y2="15"/>',
    stroke
  ),
  // 文ループ（リピート1）
  loopOne: S(
    '<path d="M17 2.5l3 3-3 3"/><path d="M20 5.5H9a5 5 0 0 0-5 5"/><path d="M7 21.5l-3-3 3-3"/><path d="M4 18.5h11a5 5 0 0 0 5-5"/><text x="12" y="15" font-size="8" font-weight="700" fill="currentColor" stroke="none" text-anchor="middle">1</text>',
    stroke
  ),
  // 全体リピート
  loopAll: S(
    '<path d="M17 2.5l3 3-3 3"/><path d="M20 5.5H9a5 5 0 0 0-5 5"/><path d="M7 21.5l-3-3 3-3"/><path d="M4 18.5h11a5 5 0 0 0 5-5"/>',
    stroke
  ),
  // 前の文 / 次の文（スキップ）
  prevSeg: S('<path d="M19 5v14l-11-7z"/><rect x="5" y="5" width="2.6" height="14" rx="1.2"/>', fill),
  nextSeg: S('<path d="M5 5v14l11-7z"/><rect x="16.4" y="5" width="2.6" height="14" rx="1.2"/>', fill),
  // この文を頭から（反時計回り）
  replay: S('<path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1"/><path d="M3 4v4.2h4.2"/>', stroke),
  // 少し戻る / 進む（早戻し・早送り）
  back5: S('<path d="M11.5 6v12l-8.5-6z"/><path d="M21.5 6v12l-8.5-6z"/>', fill),
  fwd5: S('<path d="M2.5 6v12l8.5-6z"/><path d="M12.5 6v12l8.5-6z"/>', fill),
  play: S('<path d="M7 5v14l12-7z"/>', fill),
  pause: S('<rect x="6.5" y="5" width="3.6" height="14" rx="1.2"/><rect x="13.9" y="5" width="3.6" height="14" rx="1.2"/>', fill),
  // A-B リピート
  ab: S(
    '<text x="2.5" y="11" font-size="9" font-weight="700" fill="currentColor" stroke="none">A</text><text x="13.5" y="21" font-size="9" font-weight="700" fill="currentColor" stroke="none">B</text><path d="M13 5.5h6m0 0l-2-2m2 2l-2 2"/><path d="M11 18.5H5m0 0l2-2m-2 2l2 2"/>',
    stroke
  ),
  // 音声項目のカバー（ヘッドホン）
  headphone: S('<path d="M4 14v-2a8 8 0 0 1 16 0v2"/><rect x="3" y="13.5" width="4.5" height="7.5" rx="2.2" fill="currentColor"/><rect x="16.5" y="13.5" width="4.5" height="7.5" rx="2.2" fill="currentColor"/>', stroke),
  // 全画面に（隅へ広がる矢印）
  expand: S('<path d="M8 3H3v5"/><path d="M16 3h5v5"/><path d="M8 21H3v-5"/><path d="M16 21h5v-5"/>', stroke),
  // 全画面を解除（隅から内へ）
  compress: S('<path d="M3 8h5V3"/><path d="M21 8h-5V3"/><path d="M3 16h5v5"/><path d="M21 16h-5v5"/>', stroke),
  // 目次（チャプター）＝先頭マーカー＋行
  toc: S('<line x1="9" y1="6" x2="20" y2="6"/><line x1="9" y1="12" x2="20" y2="12"/><line x1="9" y1="18" x2="20" y2="18"/><circle cx="4.5" cy="6" r="1.5"/><circle cx="4.5" cy="12" r="1.5"/><circle cx="4.5" cy="18" r="1.5"/>', stroke),
  // 再生モード: 順番（リスト＋再生三角）
  modeOrder: S('<line x1="4" y1="7" x2="14" y2="7"/><line x1="4" y1="12" x2="14" y2="12"/><line x1="4" y1="17" x2="11" y2="17"/><path d="M17 9.5v7l5-3.5z" fill="currentColor" stroke="none"/>', stroke),
  // 再生モード: シャッフル
  modeShuffle: S('<polyline points="16 4 20 4 20 8"/><path d="M4 20 20 4"/><polyline points="20 16 20 20 16 20"/><path d="M15 15l5 5"/><path d="M4 4l5 5"/>', stroke),
  // 再生モード: リピート（全体くり返し）
  modeRepeat: S('<path d="M17 2.5l3 3-3 3"/><path d="M20 5.5H9a5 5 0 0 0-5 5"/><path d="M7 21.5l-3-3 3-3"/><path d="M4 18.5h11a5 5 0 0 0 5-5"/>', stroke),
  // 再生モード: 再生したら停止（再生三角→停止バー）
  modeStop: S('<path d="M4 6v12l9-6z" fill="currentColor" stroke="none"/><rect x="16.5" y="5" width="2.8" height="14" rx="1" fill="currentColor" stroke="none"/>'),
  // ディクテーション入口（鉛筆＝書き取り）
  dictate: S('<path d="M14.5 4.5l5 5"/><path d="M4 20l1-4L16 5l3 3L8 19z"/><line x1="4" y1="20" x2="8" y2="19"/>', stroke),
  // 採点する（チェック）
  grade: S('<path d="M4 12.5l5 5L20 6.5"/>', stroke),
  // 正解を見せる（目）
  reveal: S('<path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="2.6"/>', stroke),
}
